import { FilterArrayType, FilterCombineType } from 'common/components/Filters';

export const DEFAULT_FILTER = {
  combineType: FilterCombineType.AND,
  filterKey: 'isNewApprovalSelectable',
  label: 'Yes',
  value: 'yes',
};
export const toPaymentFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case '_searchApprovalPhaseTypeId':
      case '_statusTypeId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };

      default:
        return undefined;
    }
  });

export const KEY_ALL = '-1';
